import { setCookie, removeCookie } from '@/utils/cookie';

export default {
  addDoc(state, newDocument) {
    const activeApplicationId = Number(state.applicationId);

    state.ovApplications = state.ovApplications.map(app => {
      const appId = Number(app.id);
      if (appId === activeApplicationId) {
        return {
          ...app,
          documents: [...(app.documents || []), newDocument]
        };
      }
      return app;
    });
  },
  removeDoc(state, uuid) {
    const activeApplicationId = Number(state.applicationId);

    state.ovApplications = state.ovApplications.map(app => {
      const appId = Number(app.id);
      if (appId === activeApplicationId) {
        return {
          ...app,
          documents: app.documents.filter(x => x.uuid !== uuid)
        };
      }
      return app;
    });
  },
  setApplicationId(state, id) {
    state.applicationId = id;
  },
  updateActiveApplication(state, updatedData) {
    const activeApplicationId = Number(state.applicationId);

    state.ovApplications = state.ovApplications.map(app => {
      const appId = Number(app.id);
      if (appId === activeApplicationId) {
        return {
          ...app,
          ...updatedData
        };
      }
      return app;
    });
  },
  setApplicationType(state, type) {
    state.applicationType = type;
  },
  setOvApplications(state, ovApplications) {
    state.ovApplications = ovApplications || [];
  },
  addOvApplication(state, ovApplication) {
    state.ovApplications = [...state.ovApplications, ovApplication];
  },
  setRenewalModalVisible(state, visible) {
    state.renewalModalVisible = visible;
  },
  setRouterBase(state, base) {
    state.routerBase = base;
  },
  saveInviteCode(state, inviteCode) {
    setCookie('ovInviteCode', inviteCode, 10);
    state.inviteCode = inviteCode;
  },
  removeInviteCode(state) {
    removeCookie('ovInviteCode');
    state.inviteCode = '';
  },
  setInviteError(state, inviteError) {
    state.inviteError = inviteError;
  },
  setInviteErrorUserRole(state, inviteErrorUserRole) {
    state.inviteErrorUserRole = inviteErrorUserRole;
  },
  setInviteSuccessData(state, inviteSuccessData) {
    state.inviteSuccessData = inviteSuccessData;
  },
  setIsAcceptingInvite(state, isAccepting) {
    state.isAcceptingInvite = isAccepting;
  },
  setIsFetchingApplications(state, isFetching) {
    state.isFetchingApplications = isFetching;
  }
};
